import { Link, useLocation } from "react-router-dom";
import { colors, fonts, fontSizes, logoStyle } from "../theme";

export default function TopBar() {
  const location = useLocation();

  const navItems = [
    { to: "/", label: "Home" },
    { to: "/portfolio", label: "Portfolio" },
    { to: "/playground", label: "Playground" },
  ];

  return (
    <header style={styles.wrap}>
      <div style={styles.inner}>
        <Link to="/" style={styles.brand}>
          <span style={styles.logo}>Josh Tillo</span>
        </Link>

        <nav style={styles.nav}>
          {navItems.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                style={{
                  ...styles.navLink,
                  opacity: active ? 1 : 0.85,
                  textDecoration: active ? "underline" : "none",
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

const styles = {
  wrap: {
    background: colors.topBar,
    borderBottom: "1px solid rgba(255,255,255,0.10)",
  },
  inner: {
    maxWidth: 1100,
    margin: "0 auto",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 14,
  },
  brand: { textDecoration: "none" },
  logo: {
    ...logoStyle,
    fontSize: 28,
    color: "#F3F6FA",
  },
  nav: {
    display: "flex",
    gap: 14,
    alignItems: "center",
    flexWrap: "wrap",
  },
  navLink: {
    fontFamily: fonts.heading,
    fontSize: fontSizes.small,
    fontWeight: 700,
    color: "#F3F6FA",
    textDecoration: "none",
    textUnderlineOffset: 4,
  },
};
